<template>
  <Content @back="handleBack">
    <template v-slot:nav_left>{{ recordInfo.recordName || '--' }}--提交球员</template>
    <template v-slot:nav_right>
      <template v-if="!view">
        <div v-if="edit" class="yioks_btn" @click="editRecordPlayer(recordUuid,recordYouthUuid)">添加参与本次集训球员</div>
        <div v-else class="yioks_btn" @click="addRecordPlayer(recordUuid)">添加参与本次集训球员</div>
      </template>
      <div v-if="recordAuditList.length > 0" class="yioks_btn" @click="handleViewAuditList" >审核记录</div>
    </template>
    <template v-slot:content_right>
      <div class="select_wrap">
        <div class="search_box">
          <input
            v-model.trim="selectVal.keyWord"
            type="text"
            class="yioks_input"
            placeholder="请输入关键词"
            @keyup.enter="changeQuery(true)"
          >
          <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
        </div>
      </div>
      <div class="list_wrap">
        <div v-if="showList" class="table">
          <div class="thead">
            <div class="tr">
              <div class="th seq"><strong>序号</strong></div>
              <div class="th idName"><strong>球员姓名</strong></div>
              <div class="th idNumber"><strong>球员证件号</strong></div>
              <div class="th position"><strong>位置</strong></div>
              <div class="th squadScore"><strong>成绩积分</strong></div>
              <div class="th state"><strong>球员状态</strong></div>
              <div class="th document"><strong>转会球员证明</strong></div>
              <div class="th opt"><strong>操作</strong></div>
            </div>
          </div>
          <div class="scrollArea">
            <vue-scroll>
              <div class="tbodyWrap">
                <div class="tbody">
                  <div
                    v-for="(item, index) in recordYouthList"
                    :key="index"
                    class="tr">
                    <div class="td seq">
                      <p>{{ index + 1 }}</p>
                    </div>
                    <template v-if="item.playerUuid">
                      <div class="td idName" :title="item.idName">
                        <p><span class="itemName" @click="goPlayerDetail(item.playerUuid)">{{ item.idName }}</span></p>
                      </div>
                    </template>
                    <template v-else>
                      <div class="td idName" :title="item.idName">
                        <p>{{ item.idName || '--' }}</p>
                      </div>
                    </template>

                    <div class="td idNumber" :title="item.idNumber">
                      <p>{{ item.idNumber || '--' }}</p>
                    </div>
                    <div class="td position">
                      <p>{{ item.position || '--' }}</p>
                    </div>
                    <div class="td squadScore">
                      <p>{{ item.playerScore || '--' }}分</p>
                    </div>
                    <div class="td state">
                      <p v-if="item.playerUuid">机构球员</p>
                      <p v-else>已转会</p>
                    </div>
                    <div class="td document">
                      <p v-if="item.documentUrl">
                        <a v-if="checkDownload(item.documentTitle)"
                          :href="$yioksConfig.transferBaseOnly(item.documentUrl)"
                          target="_blank"
                          title="证明文件"
                          style="font-size: 16px;line-height: 1.2em;margin-bottom: 10px;color:#4cd964"
                        >查看证明文件</a>
                        <a v-else
                          :href="$yioksConfig.transferBaseOnly(item.documentUrl)"
                          :download="item.documentUrl"
                          title="证明文件"
                          style="font-size: 16px;line-height: 1.2em;margin-bottom: 10px;color:#4cd964"
                        >查看证明文件</a>
                      </p>
                      <p v-else> -- </p>
                    </div>
                    <div class="td opt">
                      <p  v-if="!view">
                        <span class="item" @click="deleteRecord(item.uuid,item.playerScore)">删除</span>
                      </p>
                      <p v-else>
                        <span class="item" @click="viewRecordPlayer(item)">查看</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <yioks-loading v-if="loading"/>
        <template v-if="edit">
          <template v-if="!view">
            <yioks-empty v-if="empty" tips="暂时没有数据，" name="立即添加参与本次集训球员" @callback="editRecordPlayer(recordUuid,recordYouthUuid)"></yioks-empty>
          </template>
          <template v-else>
            <yioks-empty v-if="empty" tips="暂时没有数据"></yioks-empty>
          </template>
        </template>
        <template v-else>
          <yioks-empty v-if="empty" tips="暂时没有数据，" name="立即添加参与本次集训球员" @callback="addRecordPlayer(recordUuid)"></yioks-empty>
        </template>
      </div>
      <Pagination :total="total" :page.sync="page"/>
      <yioks-tip :showTip="showTip" :tipMsg="'确定删除该球员吗？'" @callback='isDelete'/>

      <template v-if="showView">
        <view-record-player
          :showView.sync="showView"
          :defaultFormData="defaultFormData"
          @hideDialog="hideDialog"
        ></view-record-player>
      </template>

      <!-- 审核日志列表 -->
      <template v-if="isShowAuditList">
        <audit-history-list
            :isShow.sync="isShowAuditList"
            :auditList="recordAuditList"
            @callback1="orgAuditCallback"
        >
        </audit-history-list>
      </template>
    </template>

  </Content>
</template>

<script>

import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/regular/trash-alt'
import 'vue-awesome/icons/regular/edit'
import record from '@/api/record'
import storage from '@/utils/storage'
import squadFormRule from '@/utils/formRules/squad'
import {ops} from '@/utils/scrollIndialog'

export default {
  components: {
    'Content': () => import('@/components/layout/list'),
    'Pagination': () => import('@/components/Pagination'),
    'view-record-player': () => import('@/components/record/viewRecordPlayer'),
    "audit-history-list": () => import("@/components/record/AuditHistoryList"),
  },
  mixins: [squadFormRule],
  data() {
    return {
      ops,
      recordYouthList: [],
      recordInfo: {},
      userRole: storage.get('userInfo').userRole,
      uuid: storage.get('userInfo').uuid,
      recordUuid: this.$route.query.uuid,
      recordType: this.$route.query.recordType,
      total: 0,
      pageSize: 20,
      page: 0,
      empty: false,
      showList: false,
      showTip: false,
      showView: false,
      loading: true,
      playerUuid: '',
      playerScore: 0,
      recordYouthUuid: '',
      edit: false,
      view: false,
      defaultFormData: {},
      selectVal: {
        uuid: '',
        keyWord: '',
      },
      recordAuditList: [], // 审核日志列表
      isShowAuditList: false, // 审核
    }
  },
  watch: {
    page() {
      this.changeQuery()
    }
  },

  filters: {
  },
  created() {
    const {page, uuid, keyWord} = this.$route.query
    page && (this.page = Number(page))
    uuid && (this.$set(this.selectVal, 'uuid', uuid));
    keyWord && (this.$set(this.selectVal, 'keyWord', keyWord))
    this.getRecordInfo() // 获取详情接口
    this.getRecordYouthInfo() // 获取详情
  },
  methods: {
    checkDownload (fileName) {
      let patten = /\.(jpg|jpeg|gif|bmp|png|pdf)$/i
      return patten.test(fileName)
    },
    handleBack() {
      this.$router.push({
        path: "/record/list",
        query: {
          idx: 1,
        }
      });
    },
    // 编辑详情接口
    getRecordInfo() {
      this.loading = true
      record.getRecordInfo(this.recordUuid).then(res => {
        if (res.code) {
          this.$message.error(res.msg)
        }
        this.recordInfo = res;
        this.loading = false;
        this.getRecordYouthList() // 获取列表
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },

    // 获取列表
    getRecordYouthList() {
      this.loading = true
      this.empty = false
      this.showList = false
      let request
      request = record.recordYouthToPlayerListYouth
      request({
        page: this.page,
        size: this.pageSize,
        recordUuid: this.recordUuid,
        keyWord: this.selectVal.keyWord,
      }).then((res) => {
        this.loading = false
        this.total = res.totalElements
        if (res.content.length) {
          this.recordYouthList = res.content
          this.showList = true
        } else {
          this.empty = true
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },

    getRecordYouthInfo() {
      record.getRecordYouthInfo(this.recordUuid).then((res) => {
        if (res) {
          if (res.auditState === 1 || res.auditState === 3){
            this.view = true;
          }
          this.recordYouthUuid = res.uuid;
          this.edit = true;

          this.getRecordAuditList(); // 获取审核日志列表
        } else {
          this.edit = false;
        }
      })
    },

    // 获取审核日志列表
    getRecordAuditList() {
      record.getRecordAuditList(this.recordUuid,this.recordYouthUuid,'trainCamp').then((res) => {
        this.recordAuditList = res;
      });
    },

    deleteRecord(uuid,playerScore) {
      this.showTip = true
      this.playerUuid = uuid
      this.playerScore = playerScore
    },
    isDelete(isSure) {
      if (isSure) {
        record.deleteRecordYouthToPlayer(this.playerUuid,this.recordYouthUuid,this.playerScore).then(res => {
          this.showTip = false
          this.getRecordYouthList()
        })
      } else {
        this.showTip = false
      }
    },

    // 集训
    addRecordPlayer(recordUuid) {
      this.$router.push({
        path: 'addRecordYouthToPlayer',
        query: {
          recordUuid,
        }
      })
    },
    editRecordPlayer(recordUuid, uuid) {
      this.$router.push({
        path: 'addRecordYouthToPlayer',
        query: {
          type: 'edit',
          recordUuid,
          uuid,
        }
      })
    },
    viewRecordPlayer(row) {
      this.showView = true;
      this.defaultFormData = row;
    },
    // 关闭对话框
    hideDialog() {
      this.showView = false;
    },


    changeQuery(flag) {
      if (flag) this.page = 0
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.page,
          uuid:this.selectVal.uuid,
          keyWord: this.selectVal.keyWord,
        }
      })
      this.getRecordYouthList()
    },

    // 查看审核记录
    handleViewAuditList() {
      this.isShowAuditList = true;
    },
    // 审核弹窗回调
    orgAuditCallback(status) {
      if (status) {
        this.$router.back();
      }
    },

    // 查看球员信息
    goPlayerDetail (uuid) {
      this.$router.push({
        path: '/player/info',
        query: {
          uuid
        }
      })
    },

  },

}
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.list_wrap
  flex 1
  overflow hidden

  .table {
    display flex
    flex-direction column
    flex 1
    width: 100%;

    .thead, .tbody {
      border: 1px solid $color_white;
    }

    .thead {
      margin: 0 40px;

      .tr {
        height: 45px;
        display: flex;
      }
    }

    .scrollArea {
      height: 425px;
      padding-bottom 15px
      /*flex 1 */
      /*overflow hidden*/
    }

    .tbodyWrap {
      display block
      // padding: 0 40px;
    }

    .tbody {
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width: 810px;
      border-top: none;
      border-bottom: none;

      .tr {
        height: 49px;
        display: flex;
        border-bottom: 1px solid $color_white;
      }
      .itemName{
        cursor pointer
        user-select none
        color $green_color
      }
    }

    .th, .td {
      height: 100%;
      /*flex: 1 1 auto;*/
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: $font_size_medium;
      border-right: 1px solid $color_white;
    }

    .th:last-child, .td:last-child {
      border-right: none;
    }

    .td {
      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: $color_white;
      }
    }

    .seq {
      width 7%
    }

    .idName {
      width 15%
    }

    .idNumber {
      width 23%
    }

    .position {
      width 12%
    }

    .squadScore {
      width 11%
    }

    .state {
      width 10%
    }

    .document {
      width 15%
    }

    .opt {
      width: 7%;

      p {
        width 100%
        text-align center

        .item {
          cursor: pointer;
          user-select: none;
          color $green_color
        }

        .split {
          margin 0 5px
        }
      }
    }
  }

.demo-ruleForm
  height 475px

.tip
  margin-top 10px
  color red
  width 100%
  text-align center
  word-break break-word

.nav_wrap {
  display: flex;
  justify-content: space-between;
  font-size: 16px;

  .nav_list {
    display: flex;

    .nav_item {
      cursor: pointer;
      user-select: none;
      padding: 10px 15px;

      &.active {
        background: $green_color;
      }
    }
  }
}
</style>

